var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],class:['full-loading', { hidden: _vm.loading }],attrs:{"element-loading-text":_vm.loadingText}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }